// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

export const CurrencySwitcher = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  border-radius: 8px;

  &:hover {
    background: ${({ theme }) => theme.colors.surfaceMuted};
  }
`;

export const SelectedConcurrency = styled.span`
  position: absolute;
  left: 12px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.ink};
  pointer-events: none;
`;

export const Arrow = styled.img.attrs({
  src: '/icons/Chevron.svg',
  alt: '',
})`
  position: absolute;
  right: 10px;
  width: 9px;
  height: 13px;
  opacity: 0.6;
  pointer-events: none;
`;

export const Select = styled.select`
  -webkit-appearance: none;
  appearance: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink};
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 9px 28px 9px 30px;
  border-radius: 8px;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.grafanaOrange};
    outline-offset: -2px;
  }
`;
